module.exports = __webpack_public_path__ + "static/img/volleyball.640d0a8.jpg";